import React from 'react'

export const DrawerHeader = ({ children }) => <p className="fs-16 fw-medium">{children}</p>
